import type { GameManifest } from "../../contracts/game";
import type { ArcadeStateV1 } from "./schema";

function matchesStarted(state: ArcadeStateV1, gameId: string): number {
  return state.games[gameId]?.matchesStarted ?? 0;
}

function lastPlayed(state: ArcadeStateV1, gameId: string): number {
  return state.games[gameId]?.lastPlayedAt ?? -1;
}

export function rankGamesByFrequency(
  games: readonly GameManifest[],
  state: ArcadeStateV1,
): GameManifest[] {
  return [...games].sort(
    (left, right) =>
      matchesStarted(state, right.id) - matchesStarted(state, left.id) ||
      lastPlayed(state, right.id) - lastPlayed(state, left.id) ||
      left.catalogOrder - right.catalogOrder ||
      left.id.localeCompare(right.id),
  );
}
